/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import {MIDIContext, MIDIEvent} from "state/midi";

type MIDIStatus = "needs_setup" | "connected" | "browser_not_supported";

const UseMIDI = (): MIDIContext => {

    const [access, setAccess] = React.useState<any | null>(null)
    const [status, setStatus] = React.useState<MIDIStatus>("needs_setup");
    const [midiDeviceNames, setMidiDeviceNames] = React.useState<string[] | null>(null)
    const [midiEventHandler, setMidiEventHandler] = React.useState<((e: MIDIEvent) => void) | null>(null)

    const handleMIDIMessage = React.useCallback((msg: any, k: any) => {
        if (!midiEventHandler) {
            return;
        }
        const data = msg.data;
        const messageType = data[0];
        if (messageType !== 144 && messageType !== 128) {
            // don't care
            return;
        }
        const key = data[1];
        const velocity = data[2];
        const time = msg.timeStamp;
        const event: MIDIEvent = {
            time,
            event_type: messageType === 128 ? "key_up" : "key_down",
            velocity,
            key: key
        };
        midiEventHandler(event);
    }, [midiEventHandler]);

    const handleMIDIDeviceChange = React.useCallback((access: any) => {
        if (!handleMIDIMessage) {
            console.log("")
            return;
        }
        const newDeviceNames = Array<string>()
        Array.from(access.inputs).forEach((input: any) => {
            newDeviceNames.push(input[1].name);
            const randNumber = Math.random();
            input[1].onmidimessage = (e: any) => {
                handleMIDIMessage(e, randNumber);
            }
        })
        setMidiDeviceNames(newDeviceNames)
    }, [handleMIDIMessage])

    React.useEffect(() => {
        if (access && handleMIDIDeviceChange) {
            handleMIDIDeviceChange(access)
            access.onstatechange = () => handleMIDIDeviceChange(access);
        }
    }, [access, handleMIDIDeviceChange]);

    React.useEffect(() => {
        async function execute() {
            if (access) {
                return;
            }
            if ((navigator as any).requestMIDIAccess) {
                const access = await (navigator as any).requestMIDIAccess();
                setAccess(access);
                setStatus("connected");
            } else {
                setStatus("browser_not_supported")
            }
        }

        execute();
    }, [access, setAccess, setStatus]);

    return {
        deviceNames: midiDeviceNames,
        status: status,
        setOnMIDIEvent: setMidiEventHandler
    };
}

export default UseMIDI;